module.exports = __webpack_public_path__ + "static/img/suning.af537493.png";